/* eslint-disable react/prop-types */

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';

import CustomerTypeScreen from '@/screens/setting/customer-type/CustomerTypeScreen';
import CustomerTypeDetailScreen from '@/screens/setting/customer-type/CustomerTypeDetailScreen';
import CustomerTypeFormScreen from '@/screens/setting/customer-type/CustomerTypeFormScreen';

const Stack = createStackNavigator();

const CustomerTypeNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="CustomerTypeScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="CustomerTypeScreen"
        component={CustomerTypeScreen}
        options={() => ({
          // headerRight (incl. the mobile Add) is owned by CustomerTypeScreen so
          // Add goes through openChild and preserves the list on return.
          title: setTitleHeader('Customer Type'),
        })}
      />
      <Stack.Screen
        name="CustomerTypeDetailScreen"
        component={CustomerTypeDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Customer Type';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                isJump={true}
                customBack={{ screen: 'CustomerTypeScreen' }}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
      <Stack.Screen
        name="CustomerTypeFormScreen"
        component={CustomerTypeFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Create Customer Type';
          let params = {};
          let isEdit = false;
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
            params = route.params;
            isEdit = true;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                isJump={true}
                customBack={{
                  screen: isEdit
                    ? 'CustomerTypeDetailScreen'
                    : 'CustomerTypeScreen',
                  params: params,
                }}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default CustomerTypeNavigator;
